var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoriesGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_37_87)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_37_87",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 18,
    height: 18,
    rx: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-1-inside-1_37_87)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-1-inside-1_37_87)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-1-inside-1_37_87)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-1-inside-1_37_87)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-1-inside-1_37_87)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_37_87",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    width: 18,
    height: 18,
    rx: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-2-inside-2_37_87)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-2-inside-2_37_87)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-2-inside-2_37_87)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-2-inside-2_37_87)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-2-inside-2_37_87)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_37_87",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 18,
    height: 18,
    rx: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-3-inside-3_37_87)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-3-inside-3_37_87)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-3-inside-3_37_87)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-3-inside-3_37_87)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-3-inside-3_37_87)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_37_87",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 24,
    width: 18,
    height: 18,
    rx: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 24,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-4-inside-4_37_87)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 24,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-4-inside-4_37_87)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 24,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-4-inside-4_37_87)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 24,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-4-inside-4_37_87)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 24,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#5DEE7A",
    strokeWidth: 6,
    mask: "url(#path-4-inside-4_37_87)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_37_87",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_37_87"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_37_87",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesGreen);
export default __webpack_public_path__ + "static/media/categories-green.c0aa4a408fddf2787ad97d2c10a6280b.svg";
export { ForwardRef as ReactComponent };